import { useMutation } from "@tanstack/react-query";
import { validateBloomreachCredentials } from "../../api/bBloomreachApi";

export const useValidateBloomreach = () => {
  return useMutation({
    mutationKey: ["validate-bloomreach"],
    mutationFn: (data) => validateBloomreachCredentials(data),
  });
};
